import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStorydocLogoLetter = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		opacity: .3,
		x: .5,
		y: .5,
		width: 31,
		height: 31,
		rx: 3.5,
		fill: "#E7E6EC",
		stroke: "#B8B3C5"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M13.9825 19.8397C13.1912 19.1029 13.3433 17.7593 13.7475 17.4559C13.6314 17.1381 13.2069 16.8202 12.6868 16.9647C11.9548 17.167 11.5129 18.0194 11.5137 18.4961C11.5341 19.2185 11.632 20.2443 13.1948 21.4001C14.6997 22.4836 17.0699 22.368 18.1863 21.5445C19.014 20.9233 19.4943 20.0131 19.5114 18.6262C19.5088 16.9792 18.4663 15.7511 17.0385 14.6531C15.958 13.8296 14.9352 12.9483 15.2421 12.0237C15.5874 10.9979 18.9412 11.4169 19.0577 11.9515C19.0965 12.0959 18.3844 12.7172 18.3846 12.8472C18.3848 12.9483 18.4234 13.0061 18.5583 13.0061C19.0401 13.0061 20.4647 12.0959 20.5022 11.4025C20.5211 11.1713 19.7299 10.5067 19.4213 10.3334C18.3604 9.74101 16.6066 9.63988 15.1042 10.1022C14.1025 10.3911 13.4098 11.0702 13.3342 12.0237C13.2203 13.1073 13.6843 14.0174 15.3822 15.3177C16.5012 16.1701 17.9669 16.8347 17.9497 18.1638C17.914 19.9553 15.3142 21.0967 13.9825 19.8397Z",
		fill: "#594F78"
	})]
});
const ForwardRef = forwardRef(SvgStorydocLogoLetter);
export default ForwardRef;
